import React, { useEffect, useRef } from "react";
import { TextContainer, Subheading } from "../styles/components/Global/Text";
import animations from "./Animations";

const SubheadingText = ({
  text,
  width,
  align,
  textAlign,
  weight,
  parallax,
  zIndex,
}) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);
  return (
    <TextContainer ref={containerRef} $align={align} $zIndex={zIndex} $flex>
      <Subheading
        $width={width}
        $textAlign={textAlign}
        $weight={weight}
        dangerouslySetInnerHTML={{ __html: text }}
      ></Subheading>
    </TextContainer>
  );
};

SubheadingText.defaultProps = {
  width: "small",
  align: "center",
  textAlign: "center",
  weight: "normal",
  parallax: true,
  zIndex: false,
};

export default SubheadingText;
